<template>
    <div class="w-full py-5">
        <div class="flex">
            <slot />
        </div>
    </div>
</template>

<script>
import SvgIcon from '../ui/SvgIcon.vue';
import Item from './Item.vue';
export default {
    name: 'StepsContainer',
    components: { Item, SvgIcon }
}
</script>

<style>

</style>
